export const DecisionModuleType = {
    ADVICE: 'advice',
    DECISION: 'decision'
}

export const AdviceOutcome = {
    HIGH: 'high',
    MEDIUM: 'medium',
    LOW: 'low'
};

export const DecisionOutcome = {
    POSITIVE: 'positive',
    NEGATIVE: 'negative'
}
